import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function DateProperties({ question }) {
  return <QuestionLabel question={question} />
};